import React, { useState } from "react";
import { IconButton } from "@mui/material";
import PropTypes from "prop-types";
import { FormFeedback, Input } from "reactstrap";
import { get } from "lodash";
import { ReactComponent as ShowPasswordIcon } from "assets/images/svg/passwordshowIcon.svg";
import { ReactComponent as HidePasswordIcon } from "assets/images/svg/passwordHiddenIcon.svg";

const InputField = ({ name, placeholder, type, formik, id }) => {
  const [passwordToggle, setPasswordToggle] = useState(false);

  const { touched, values, errors, handleBlur, handleChange } = formik || {};

  const handleClickShowPassword = () => {
    setPasswordToggle((prev) => !prev);
  };

  return (
    <div className="input-field-wrapper">
      <Input
        id={id}
        name={name}
        value={get(values, name, "")}
        placeholder={placeholder}
        type={
          type === "password" ? (passwordToggle === true ? "text" : type) : type
        }
        className={`${
          type === "password" ? "inputField  password" : "inputField"
        }`}
        onChange={handleChange}
        onBlur={handleBlur}
        invalid={!!touched[name] && errors[name]}
      />

      {type === "password" && (
        <div onClick={handleClickShowPassword} className="password-show-icon">
          <IconButton>
            {passwordToggle ? <ShowPasswordIcon /> : <HidePasswordIcon />}
          </IconButton>
        </div>
      )}
      {touched[name] && errors[name] ? (
        <FormFeedback type="invalid" className="error-message ms-3">
          {errors[name]}
        </FormFeedback>
      ) : null}
    </div>
  );
};

InputField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  formik: PropTypes.object,
  id: PropTypes.string,
};

export default InputField;
